import vue from "../../../../main"; // webpack alias

export default function(context) {
  let result = context.$store.dispatch("confirmDialog", {
    content: vue.$t("components.actions.delegationOrder.submitConfirm.content"),
    title: vue.$t("components.actions.delegationOrder.submitConfirm.title")
  });
  result.then(() => {
    //TODO KOMUNIKAT TRWA PRZETWARZANIE
    vue
      .axios({
        url: "delegation-order/submit",
        data: { id: context.contextItemId },
        method: "POST"
      })
      .then(resp => {
        if (resp.data.status === "OK") {
          context.$store.dispatch("DelegationOrder/loadAllDelegationOrders");
        } else if (resp.data.status === "error") {
          //TODO WYSWIETLENIE DYMKA BLEDU WALIDACJI
        }
      })
      .catch(() => {
        //TODO obsluga bledow
      });
  });
}
